<div *ngIf="dataLoading">
  <h3 class="loading-title">Loading frames</h3>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<section class="awaiting-frames" *ngIf="!dataLoading">
  <header class="ao-page-head">
    <div>
      <div class="ao-eyebrow">Frame orders</div>
      <h2>Awaiting frames</h2>
    </div>
    <div class="summary">
      {{ vendorsLabel(vendorTotal) }} · {{ framesLabel(totalFrames) }}
    </div>
  </header>

  <div class="vendor-list">
    <div class="vendor-block" *ngFor="let order of dataSource.data; let i = index">
      <button
        type="button"
        class="vendor-bar"
        [class.open]="expandedElement === order"
        (click)="toggleExpanded(order, i)"
      >
        <span
          class="alert-col"
          [class.empty]="!hasPatientOrder(order)"
          [attr.aria-label]="hasPatientOrder(order) ? 'Patient order waiting' : null"
        >
          <mat-icon *ngIf="hasPatientOrder(order)">notifications</mat-icon>
        </span>
        <span class="vendor-name">{{ order.vendor.name }}</span>
        <span class="vendor-meta">{{ framesLabel(frameCount(order)) }}</span>
        <span class="vendor-meta">
          {{ hasPatientOrder(order) ? patientsLabel(patientCount(order)) : 'Stock only' }}
        </span>
        <mat-icon class="chevron">{{ expandedElement === order ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>

      <div class="vendor-open" *ngIf="expandedElement === order">
        <div class="vendor-identity">
          <div class="who">
            <span class="avatar">{{ vendorInitial(order.vendor.name) }}</span>
            <div>
              <div class="who-kicker">Vendor</div>
              <div class="who-name">{{ order.vendor.name }}</div>
            </div>
          </div>
          <div class="vendor-meta-grid">
            <div class="stat center">
              <span class="k">Frames</span>
              <span class="v">{{ frameCount(order) }}</span>
            </div>
            <div class="stat center">
              <span class="k">Account</span>
              <span class="v">{{ order.vendor.accountNumber }}</span>
            </div>
            <div class="stat">
              <span class="k">Representative</span>
              <span class="v">{{ order.vendor.repName }}</span>
            </div>
            <div class="stat">
              <span class="k">Phone</span>
              <a *ngIf="phoneOf(order.vendor)" [href]="telHref(phoneOf(order.vendor))">
                <mat-icon>phone</mat-icon>{{ phoneOf(order.vendor) }}
              </a>
            </div>
            <div class="stat">
              <span class="k">Email</span>
              <a *ngIf="emailOf(order.vendor)" [href]="'mailto:' + emailOf(order.vendor)">
                <mat-icon>mail</mat-icon>{{ emailOf(order.vendor) }}
              </a>
            </div>
          </div>
        </div>

        <app-awaiting-frames-orders
          [vendorOrders]="order"
          [orderIndex]="i"
          (refreshOrders)="refreshOrders()"
        ></app-awaiting-frames-orders>
      </div>
    </div>
  </div>
</section>
